// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import router from './permission'
import Subnet from './components/subnet'
import ViewUI from 'view-design'
import Vuex from 'vuex'
import axios from 'axios'
import store from '@/store'
import './styles/theme.less'
import util from './libs/util'
import moment from 'moment'
import 'xterm/css/xterm.css'
import Clipboard from 'clipboard';
import config from '@/config'
import JsonExcel from 'vue-json-excel'
import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'

/* eslint-disable no-new */
Vue.config.productionTip = false
/**
 * @description 全局注册应用配置
 */
Vue.prototype.$config = config
/**
 * @description 全局注册工具
 */
Vue.prototype.$util = util
Vue.prototype.Clipboard = Clipboard;
Vue.use(moment)
Vue.use(VXETable)
Vue.use(Vuex)
Vue.use(ViewUI)
Vue.component('downloadExcel', JsonExcel)

Vue.prototype.$http = axios
new Vue({
  el: '#Subnet',
  template: '<Subnet/>',
  components: {Subnet},
  store: store,
  router
})



// WEBPACK FOOTER //
// ./src/main.js